import {CLEAR_ERROR} from "../types";
import Api from '../../services/Api'

export const validate = (url, type) => dispatch => {

    return new Promise((resolve, reject) => {
        Api.get(url)
        .then(res => res.data)
        .then(posts => {
            dispatch({
                type,
                payload: posts
            });

            resolve();
        });
    });
};

export const clearError = () => dispatch =>{
    dispatch({
        type: CLEAR_ERROR,
        payload: []
    })
}


// WEBPACK FOOTER //
// ./src/actions/ValidationActions/serverValidation.js